import { APP_URL, getRnd } from 'lib/utils/urlUtils';

const resetPasswordURL = `${APP_URL}/auth/resetPassword`;

export const requestPassword = async (customerId, email) => {
  const url = new URL(resetPasswordURL);
  url.searchParams.set('rnd', getRnd());
  return await fetch(url, {
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      email: email,
      username: customerId,
    }),
    method: 'POST',
    credentials: 'same-origin',
  });
};
